import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h2>404 - Page Not Found</h2>
      <p>The requested page could not be found.</p>
    </div>
  );
};

export default NotFound;
